<template>
	<div class="back" v-if="$route.path !== '/'">
		<a href="#" @click.prevent="$router.go(-1)">Вернуться назад</a>
	</div>
</template>

<script>
  export default {
    name: "back",
    data() {
      return {}
    },
    props: {
      items: ''
    },
    methods: {}
  }
</script>